<template>
  <section class="container">
    <layout-breadcrumb :items="breadcrumbs"></layout-breadcrumb>
    
    
    <!-- Loading State -->
    <div v-if="cargando" class="row justify-content-center">
      <div class="col-md-10">
        <div class="card">
          <div class="card-body text-center p-5">
            <div class="spinner-border text-transparencia" role="status">
              <span class="sr-only">Cargando...</span>
            </div>
            <p class="mt-3 text-muted">Cargando detalles del módulo...</p>
          </div>
        </div>
      </div>
    </div>

    <!-- Error State -->
    <div v-else-if="error" class="row justify-content-center">
      <div class="col-md-10">
        <div class="card">
          <div class="card-body text-center p-5">
            <i class="fa fa-exclamation-triangle fa-3x text-warning mb-3"></i>
            <h5 class="text-muted">Error al cargar el módulo</h5>
            <p class="text-muted">{{ errorMessage }}</p>
            <button @click="fetchData" class="btn btn-outline-primary">
              <i class="fa fa-refresh mr-1"></i> Reintentar
            </button>
          </div>
        </div>
      </div>
    </div>

    <!-- Module Detail -->
    <div v-else-if="datos && Object.keys(datos).length > 0" class="row justify-content-center">
      <div class="col-md-10">
        <div class="card modulo-detail-card">
          <div class="card-header bg-transparencia text-white">
            <h4 class="mb-0">
              <i class="fa fa-graduation-cap mr-2"></i>
              {{ datos.titulo }}
            </h4>
          </div>
          <div class="card-body">

            <!-- Module Video -->
            <div v-if="datos.rutaVideo" class="row mb-4">
              <div class="col-md-12">
                <div class="modulo-video-container">
                  <div class="video-wrapper ratio-16x9">
                    <iframe 
                      title="video" 
                      :src="getEmbedUrl(datos.rutaVideo)" 
                      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" 
                      allowfullscreen="" 
                      frameborder="0">
                    </iframe>
                  </div>
                </div>
              </div>
            </div>

            <!-- Module Description -->
            <div class="row">
              <div class="col-md-12">
                <div class="modulo-description-content">
                  <div v-html="datos.descripcion"></div>
                </div>
              </div>
            </div>

            <!-- Back Button -->
            <div class="row mt-4">
              <div class="col-md-12 text-center">
                <router-link to="/voluntariado/escuela-observadores-democraticos/modulos" class="btn btn-outline-primary">
                  <i class="fa fa-arrow-left mr-2"></i>
                  Volver a Módulos
                </router-link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- No Data State -->
    <div v-else class="row justify-content-center">
      <div class="col-md-10">
        <div class="card">
          <div class="card-body text-center p-5">
            <i class="fa fa-graduation-cap fa-3x text-muted mb-3"></i>
            <h5 class="text-muted">Módulo no encontrado</h5>
            <p class="text-muted">El módulo solicitado no existe o no está disponible</p>
            <router-link to="/voluntariado/escuela-observadores-democraticos/modulos" class="btn btn-primary">
              <i class="fa fa-arrow-left mr-1"></i> Volver a Módulos
            </router-link>
          </div>
        </div>
      </div>
    </div>

  </section>
</template>

<script>
import layoutBreadcrumb from "@/layout/layout-breadcrumb";

export default {
  name: "view-modulo-eod-detail",
  metaInfo: {
    title: "Detalle del Módulo EOD",
  },
  components: { 
    layoutBreadcrumb
  },
  data: () => ({
    datos: {},
    cargando: false,
    error: false,
    errorMessage: '',
    breadcrumbs: [],
    moduloId: null,
  }),
  methods: {
    async fetchData() {
      if (!this.moduloId) {
        this.error = true;
        this.errorMessage = 'ID del módulo no proporcionado';
        return;
      }

      this.cargando = true;
      this.error = false;
      
      try {
        const response = await this.$http.get(this.apiRoute("Volunteering", "GetVoluntariadoEodModuloById"), {
          params: { id: this.moduloId }
        });
        
        if (!response.body.error) {
          this.datos = response.body.data || {};
        } else {
          this.error = true;
          this.errorMessage = response.body.message || 'Error al cargar los datos del módulo';
        }
      } catch (error) {
        this.error = true;
        this.errorMessage = 'Error de conexión al servidor';
      } finally {
        this.cargando = false;
      }
    },

    getEmbedUrl(url) {
      if (!url) return '';
      
      // Si ya es una URL embebida, devolverla tal como está
      if (url.includes('/embed/')) {
        return url;
      }
      
      // Convertir URL de YouTube a formato embebido
      if (url.includes('youtube.com/watch') || url.includes('youtu.be/')) {
        let videoId = '';
        
        if (url.includes('youtube.com/watch')) {
          const match = url.match(/[?&]v=([^&]+)/);
          videoId = match ? match[1] : '';
        } else if (url.includes('youtu.be/')) {
          const match = url.match(/youtu\.be\/([^?]+)/);
          videoId = match ? match[1] : '';
        }
        
        if (videoId) {
          return `https://www.youtube.com/embed/${videoId}`;
        }
      }
      
      // Para otros tipos de video, devolver la URL original
      return url;
    },

  },
  mounted: async function() {
    this.moduloId = this.$route.params.id;
    
    this.breadcrumbs = [
      { name: "Inicio", url: "/home", icon: "fa fa-home", active: false },
      { name: "Voluntariado", url: "/voluntariado", icon: "", active: false },
      { name: "Escuela de Observadores Democráticos", url: "/voluntariado/escuela-observadores-democraticos", icon: "", active: false },
      { name: "Módulos", url: "/voluntariado/escuela-observadores-democraticos/modulos", icon: "", active: false },
      { name: "Detalle", url: "", icon: "", active: true },
    ];
    
    await this.fetchData();
  },
};
</script>

<style scoped>
.card {
  box-shadow: 0 2px 4px rgba(0,0,0,0.1);
}

.modulo-detail-card {
  border: none;
}

.bg-transparencia {
  background-color: #2484da !important;
}

.text-transparencia {
  color: #2484da !important;
}


.modulo-video-container {
  background: #f8f9fa;
  border-radius: 8px;
  padding: 1rem;
}

.video-wrapper {
  position: relative;
  width: 100%;
  height: 0;
  padding-bottom: 56.25%; /* 16:9 aspect ratio */
}

.video-wrapper iframe {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  border-radius: 8px;
}

.modulo-description-content {
  background: #f8f9fa;
  padding: 2rem;
  border-radius: 8px;
  border-left: 4px solid #2484da;
}

.modulo-description-content h1,
.modulo-description-content h2,
.modulo-description-content h3,
.modulo-description-content h4,
.modulo-description-content h5,
.modulo-description-content h6 {
  color: #2484da;
  margin-bottom: 1rem;
}

.modulo-description-content p {
  margin-bottom: 1rem;
  line-height: 1.6;
}

.modulo-description-content ul,
.modulo-description-content ol {
  margin-bottom: 1rem;
  padding-left: 2rem;
}

.modulo-description-content li {
  margin-bottom: 0.5rem;
}

.btn-primary {
  background-color: #2484da !important;
  border-color: #2484da !important;
}

.btn-primary:hover {
  background-color: #1e6bb8 !important;
  border-color: #1e6bb8 !important;
}

.btn-outline-primary {
  color: #2484da;
  border-color: #2484da;
}

.btn-outline-primary:hover {
  background-color: #2484da;
  border-color: #2484da;
}


/* Responsive */
@media (max-width: 768px) {
  .container .row {
    margin-left: -15px;
    margin-right: -15px;
  }
  
  .container .col-md-10,
  .container .col-md-12 {
    padding-left: 15px;
    padding-right: 15px;
  }

  .modulo-description-content {
    padding: 1rem;
  }

}
</style>
